import React, { useState, useEffect, useRef } from "react";
import FullCalendar, { formatDate } from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import axiosInstance from "../../../../../../axios";
import OverlayContainer from "@components/Overlay/OverlayContainer";
import { Loading } from "../../../../../Other/Loading";
import moment from "moment";
import { useParams } from "react-router-dom";

const WebinarScheduler = (props) => {
  const now = new Date();
  const params = useParams()
  const today = moment(now).format("DD-MM-YYYY");
  const firstDay = moment(
    new Date(now.getFullYear(), now.getMonth(), 1)
  ).format("YYYY MM,DD");
  const lastDay = moment(
    new Date(now.getFullYear(), now.getMonth() + 1, 0)
  ).format("YYYY MM,DD");
  const state = {
    weekendsVisible: true,
    currentEvents: [],
  };
  // const Id = props?.history?.location?.state?.courseId;
  //console.log("params", params);
  const Id = params?.id
  //console.log("props", props)
  const [check, setCheck] = useState(state);
  const [deleteModal, setDeleteModal] = useState(false);
  const [scheduleEvent, setScheduleEvent] = useState([]);
  const [popUp, setPopUp] = useState(false);
  const [response, setResponse] = useState(false);
  const [eventId, setEventId] = useState();
  const [selectInfo, setSelectInfo] = useState();
  const [formErrors, setFormErrors] = useState({});
  const [eventDetails, setEventDetails] = useState({
    startTime: "",
    eventName: "",
    endTime: "",
    startDate: "",
    endDate: "",
  });

  const centralizeData = (response) => {
    return response?.map((el) => ({
      start: moment(el.webinarDate).format("YYYY-MM-DD"),
      title: el.eventName,
      id: el.id,
      eventEndTime: el.endTime,
      eventStartTime: el.startTime,
      endDate: el.endDate,
    }));
  };
  useEffect(() => {
    const fetchWebinarSchedule = async () => {
      try {
        const response = await axiosInstance.get(`webinar/all?startDate=${firstDay}&endDate=${lastDay}`);
        setScheduleEvent(centralizeData(response.data.data));
      } catch (err) {
        console.error("Error fetching webinar schedule:", err.message);
      }
    };

    fetchWebinarSchedule();
  }, []);


  const handleDateSelect = (selectInfo) => {
    const today = moment(now).format("D");
    const month = moment(now).format("MM");
    const current = parseInt(moment(selectInfo.startStr).format("DD-MM"));
    const currentmonth = parseInt(moment(selectInfo.startStr).format("MM"));

    if (current >= today && currentmonth >= month) {
      setEventDetails({
        ...eventDetails,
        startDate: moment(selectInfo.startStr).format("YYYY-MM-DD"),
        endDate: moment(selectInfo.startStr).format("YYYY-MM-DD"),
      });
      setPopUp(!popUp);
      setSelectInfo(selectInfo);
    }
  };

  useEffect(() => {
    if (formErrors.success === true) {
      eventSchedule();
    }
  }, [formErrors]);

  const createEvent = () => {
    let title = eventDetails.eventName;
    let calendarApi = selectInfo.view.calendar;

    calendarApi.unselect();
    if (title) {
      calendarApi.addEvent({
        // id: createEventId(),
        title: title,
        start: selectInfo.startStr,
        end: selectInfo.endStr,
        allDay: selectInfo.allDay,
      });
    }
    setEventDetails({});
  };

  const eventDeleteHandler = async () => {
    const data = {
      webinarId: eventId.event._def.publicId,
    };

    try {
      const response = await axiosInstance.post("webinar/delete", data);

      if (response.data.message === "Webinar deleted successfully") {
        setDeleteModal(!deleteModal);
        eventId.event.remove();
      }
    } catch (err) {
      console.error("Error deleting webinar:", err.message);
    }
  };


  const handleEventClick = (clickInfo) => {
    setEventId(clickInfo);
    setDeleteModal(!deleteModal);
    // if (
    //   window.confirm(
    //     `Are you sure you want to delete the event '${clickInfo.event.title}'`
    //   )
    // ) {
    //   clickInfo.event.remove();
    // }
  };

  const inputHandler = (e) => {
    const name = e.target.name;
    const values = e.target.value;
    setEventDetails({ ...eventDetails, [name]: values });
  };

  const updateEvent = () => {
    setScheduleEvent((current) =>
      current.map((obj) => {
        if (eventDetails.webinarId === obj.id) {
          return {
            title: eventDetails.eventName,
            eventStartTime: eventDetails.startTime,
            eventEndTime: eventDetails.endTime,
            id: eventDetails.webinarId,
            start: eventDetails.startDate,
          };
        }
        return obj;
      })
    );
  };

  const eventSchedule = async () => {
    setResponse(true);

    try {
      if (eventDetails.webinarId) {
        const response = await axiosInstance.post("webinar/update", {
          webinarId: eventDetails.webinarId,
          webinarDate: eventDetails.startDate,
          eventName: eventDetails.eventName,
          startTime: eventDetails.startTime,
          endTime: eventDetails.endTime,
        });

        updateEvent();
        setPopUp(false);
      } else {
        const response = await axiosInstance.post(`webinar/course/${Id}`, eventDetails);

        props.schedule({ ...props.formValues, scheduleEvent: "event" });
        setPopUp(false);
        createEvent();
      }
    } catch (err) {
      console.error("Error scheduling event:", err.message);
    } finally {
      setResponse(false);
    }
  };


  const validate = () => {
    const error = {};
    if (!eventDetails.eventName) {
      error.eventName = "Event Date is required";
    } else if (!eventDetails.startDate) {
      error.startDate = "Start Date is required";
    } else if (!eventDetails.startTime) {
      error.startTime = "Start Time is required*";
    } else if (!eventDetails.endTime) {
      error.endTime = "End Time is required*";
    } else if (eventDetails) {
      error.success = true;
    }
    return setFormErrors(error);
  };

  const editTableHandler = () => {
    setDeleteModal(!deleteModal);

    scheduleEvent.map((events) => {
      if (eventId.event._def.publicId == events.id) {
        setEventDetails({
          webinarId: events.id,
          startTime: events.eventStartTime,
          eventName: events.title,
          endTime: events.eventEndTime,
          startDate: events.start,
          endDate: events.endDate,
        });
      }
    });
    setPopUp(!popUp);
  };

  const cancelEventHandler = () => {
    setPopUp(!popUp);
    setEventDetails({
      startTime: "",
      eventName: "",
      endTime: "",
      startDate: "",
      endDate: "",
    });
  };

  return (
    <>
      <div className="FullCalendarevent">
        {deleteModal && (
          <div className="custom-popup">
            <div className="custom-popup-inner">
              <div className="EventDeletePreview">
                <div onClick={() => setDeleteModal(!deleteModal)}>
                  <i className="icon check"></i>
                </div>
              </div>
              <div className="deleteEventtext">Choose Your Action</div>
              <div className="deleteEvent-actions">
                {props.current === null ? (
                  <button
                    className="btn webinar-schedular edit-btn-webiner"
                    onClick={editTableHandler}
                  >
                    Edit
                  </button>
                ) : (
                  <button
                    className="btn webinar-schedular edit-btn-webiner"
                    onClick={() => setDeleteModal(!deleteModal)}
                  >
                    Cancel
                  </button>
                )}
                <button
                  className="btn webinar-schedular delete-btn-webiner"
                  onClick={eventDeleteHandler}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        )}

        {popUp && (
          <div className="liveScheduler">
            <div className="liveHeader"> LIVE Event Scheduler</div>

            <div className="liveSubHeader"> Event Date + Time Zone</div>
            <div className="liveDate">
              <span>{today}</span>
            </div>
            <div className="live-col">
              <div> Event Name</div>
              <input
                type="text"
                name="eventName"
                value={eventDetails.eventName}
                onChange={inputHandler}
              />
              <div>{formErrors?.eventName}</div>
            </div>
            <div className="liveRow">
              <div className="live-col">
                <div> Event Start Date</div>
                <input
                  type="date"
                  name="startDate"
                  onChange={inputHandler}
                  value={eventDetails.startDate}
                />
                <div>{formErrors?.startDate}</div>
              </div>
              <div className="live-col">
                <div> Event End Date</div>
                <div>
                  <input
                    type="date"
                    name="endDate"
                    onChange={inputHandler}
                    value={eventDetails.endDate}
                  />
                  <div>{formErrors?.endDate}</div>
                </div>
              </div>
            </div>

            <div className="liveRow">
              <div className="live-col">
                <div> Event Start Time</div>
                <input
                  type="time"
                  name="startTime"
                  onChange={inputHandler}
                  step="1"
                  value={eventDetails.startTime}
                />
                <div>{formErrors?.startTime}</div>
              </div>
              <div className="live-col">
                <div> Event End Time</div>
                <div>
                  <input
                    type="time"
                    name="endTime"
                    onChange={inputHandler}
                    step="1"
                    value={eventDetails.endTime}
                  />
                  <div>{formErrors?.endTime}</div>
                </div>
              </div>
            </div>

            <div className="liveInfo">
              Is this webinar a single event or a recurring event?
            </div>
            <div className="singleEventSlect">
              <select
                onChange={inputHandler}
                name="intervalType"
                value={eventDetails.intervalType}
              >
                <option value="SingleEvent"> Single Event </option>
                <option value="Weeks"> Weeks </option>
              </select>
            </div>
            <div className="liveBtn">
              {!response && (
                <button className="blueBtn" onClick={validate}>
                  SCHEDULE LIVE WEBINAR NOW
                </button>
              )}
              {response && <Loading></Loading>}
            </div>

            <div className="liveBtn">
              <button className="greyBtn" onClick={cancelEventHandler}>
                CANCEL EVENT
              </button>
            </div>
          </div>
        )}

        <FullCalendar
          schedulerLicenseKey={"GPL-My-Project-Is-Open-Source"}
          plugins={[
            dayGridPlugin,
            timeGridPlugin,
            interactionPlugin,
            resourceTimelinePlugin,
          ]}
          headerToolbar={{
            left: "prev,next",
            center: "title",
            right: "dayGridMonth,timeGridWeek,resourceTimelineDay",
          }}
          editable={true}
          eventBackgroundColor="#f4e6fd"
          selectable={true}
          selectHelper={true}
          eventRender={(event, element) => {
            element.popover({
              animation: true,
              delay: 300,
              content:
                "<b>Inicio</b>:" + event.start + "<b>Fin</b>:" + event.end,
              trigger: "hover",
            });
          }}
          selectMirror={true}
          dayMaxEvents={true}
          weekends={check.weekendsVisible}
          select={handleDateSelect}
          events={scheduleEvent}
          eventClick={handleEventClick}
        />
      </div>
    </>
  );
};
export default WebinarScheduler;
